import cn from 'classnames';
import { Tile } from '@creditflowresearch/uilib/Tile';
import CorporateMarketDealHeader from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealHeader/CorporateMarketDealHeader';
import CorporateMarketDealsTable from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/CorporateMarketDealsTable';
import { IssueTileProps } from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/IssueTile';

import styles from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/issueTile.module.scss';

export const CorporateMarketIssueTile = ({
  defaultExpandedRowIndexes,
  showDealDetailsByDefault,
  containerClassName,
}: IssueTileProps) => (
  <Tile dataTest="dealTile" className={ cn(styles.container, containerClassName) }>
    <CorporateMarketDealHeader>
      <CorporateMarketDealsTable
        showDealDetailsByDefault={ showDealDetailsByDefault }
        defaultExpandedRowIndexes={ defaultExpandedRowIndexes }
      />
    </CorporateMarketDealHeader>
  </Tile>
);

export default CorporateMarketIssueTile;
